import { Icon, Text, HStack } from '@televet/kibble-ui';
import React from 'react';

interface IMobileMenuItem {
  onClick: () => void;
  hasIcon?: boolean;
  text: string;
}

const MobileMenuItem = ({ onClick, text, hasIcon = true }: IMobileMenuItem): JSX.Element => {
  return (
    <HStack h={12} cursor="pointer" justifyContent="space-between" onClick={onClick} px={5}>
      <Text size="md">{text}</Text>
      {hasIcon && <Icon name="chevronRight" size="md" />}
    </HStack>
  );
};

export default MobileMenuItem;
